import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DiscussYourCase() {
  return <section data-section-id="166949" id="ajukan-kerjasama-cta" className="bg-background py-24 md:py-32 px-6 flex flex-col items-center justify-center text-center">
      <div className="max-w-2xl mx-auto flex flex-col items-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-bold text-foreground mb-10">
          Ajukan Kerjasama.
        </h2>
        <Button asChild className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-[400ms] font-sans text-[14px] tracking-[0.1em] h-auto py-4 px-8 uppercase focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:outline-none shadow-sm">
          <Link to="#">
            Ajukan Kerjasama
          </Link>
        </Button>
      </div>
    </section>;
}